import { formatDateOrDash } from '#/utils/date';

import SignReceiptStatusBadge from '#/modules/crmMgmt/aftersales/signReceipt/components/SignReceiptStatusBadge';

export const signReceiptSideMsgStatusBlock = {
  fields: [
    {
      key: 'status',
      label: '狀態',
      render: (row) => (
        <div className="side_msg-row">
          <h3>狀態</h3>
          <SignReceiptStatusBadge status={row?.status} size="default" />
        </div>
      ),
    },
  ],
};

export const signReceiptSideMsgDetailBlock = {
  fields: [
    { label: '簽收單號', value: 'signReceiptNo' },
    {
      label: '預計送交日',
      value: (row) => formatDateOrDash(row?.signReceiptDate),
    },
    { label: '客戶名稱', value: 'customerName' },
    { label: '聯絡人', value: 'contactName' },
    { label: '電話', value: 'phone' },
    { label: '備註', value: 'remark' },
  ],
};

export const signReceiptSideMsgBlocks = [
  signReceiptSideMsgStatusBlock,
  signReceiptSideMsgDetailBlock,
];
